var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"}],staticClass:"scroll-on-top-btn",class:{
      'scroll-top-with-recaptcha': _vm.recaptchaTokenEnabled
    },attrs:{"fab":"","fixed":"","bottom":"","right":"","depressed":"","color":"primary","height":"48","width":"48"},on:{"click":_vm.toTop}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }